import { types, flow } from 'mobx-state-tree';

import { CareerPage as API } from '@src/services/companies';
import { getCompanyDomain } from '@src/helpers';

const Partner = types.model('Partner', {
  id: types.number,
  url: types.string,
  name: types.string,
  slug: types.string,
  logo_url: types.maybeNull(types.string),
  is_allow_listing: types.boolean,
  change_listing_url: types.string
});

const CareerPageData = types.model('CareerPageData', {
  careers_url: types.optional(types.string, ''),
  jobs_iframe_without_filter: types.optional(types.string, ''),
  jobs_iframe_with_filter: types.optional(types.string, ''),
  jobs_widget_without_filter: types.optional(types.string, ''),
  jobs_widget_with_filter: types.optional(types.string, ''),
  company_promoters: types.array(Partner)
});

export const CareerPageStore = types
  .model('CareerPageStore', {
    isFetching: types.optional(types.boolean, false),
    data: types.optional(CareerPageData, {})
  })
  .actions(self => {
    return {
      fetchCareerPages: flow(function* fetch() {
        const companyId = getCompanyDomain();
        try {
          const res = yield API.getCareerPageData(companyId);
          self.data = res;
        } catch (error) {}
      })
    };
  })
  .actions(self => ({
    fetchData: flow(function* fetch() {
      self.isFetching = true;
      try {
        yield self.fetchCareerPages();
        self.isFetching = false;
      } catch (error) {
        self.isFetching = false;
      }
    }),
    changePartnerListing: flow(function* fetch(partnerCompanyId) {
      const companyId = getCompanyDomain();
      try {
        yield API.changePartnerListing({
          companySlug: companyId,
          partnerCompanyId,
          allowListing: !self.data.company_promoters.find(({ id }) => id === partnerCompanyId)?.is_allow_listing
        });
        yield self.fetchCareerPages();
      } catch (error) {}
    })
  }));
